import { render, staticRenderFns } from "./archived.vue?vue&type=template&id=51f23ee0&scoped=true&"
import script from "./archived.vue?vue&type=script&lang=js&"
export * from "./archived.vue?vue&type=script&lang=js&"
import style0 from "./archived.vue?vue&type=style&index=0&id=51f23ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f23ee0",
  null
  
)

export default component.exports